<div class="header">
  <div class="container">
    <div class="holder" *ngIf="!connected">
      <div class="link-home margin-auto">
        <a [routerLink]="['/login']" class="logo-router">
          <span class="title" i18n>simple. clair. helvetia</span>
          <img class="logo" src="./assets/img/triangle-helvetia.png" />
        </a>
      </div>
    </div>
    <div class="holder" *ngIf="connected">
      <a [routerLink]="['/documents']" class="link-home">
        <span class="title">L'AppliCom</span>
      </a>
      <div class="title-menu">
        <p class="medium-text" i18n>{{ menuItem }}</p>
      </div>
      <div class="link-home">
        <div class="logo-router">
          <span class="title">helvetia</span>
          <img class="logo" src="./assets/img/triangle-helvetia.png" />
        </div>
      </div>
    </div>
  </div>
</div>